/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idLeadCorretor: string;
  idUnidade: string;
  porcentagem: string;
  valorProposta: string;
  valorTotal: string;
  numeroParcelas: string;
}

export function useAplicarPosChaves() {
  function toNumber(brNumber: string): number {
    const numberWithoutDots = brNumber.replace(/\./g, "");
    const numberWithDot = numberWithoutDots.replace(",", ".");
    return parseFloat(numberWithDot);
  }
  const putData = async (props: Props) => {
    const APLICAR_POS_CHAVES = `${backofficeEnviroment}/common/oportunidades-lead/calcular-prosoluto-poschaves/vivaz/v1`;
    const { data } = await instance.put(APLICAR_POS_CHAVES, {
      idLeadCorretor: props.idLeadCorretor,
      idUnidade: props.idUnidade,
      porcentagem: toNumber(props.porcentagem),
      valorProposta: toNumber(props.valorProposta),
      valorTotal: props.valorTotal,
      numeroParcelas: 25,
    });
    return data;
  };

  const mutation = useMutation(putData, {
    onSuccess: () => {
      // toast.success("Resumo de pagamento inserido com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao aplicar porcentagem", error);
    },
  });

  return mutation;
}
